import { upperFirst, camelCase } from 'lodash-es'

const EVENT_TYPE_FEATURE_RESTRICTIONS = {
  page: {
    group: 'team_scheduling',
    collective: 'collective_event_types',
    round_robin: 'round_robin_event_types'
  },
  personal: {
    solo: 'event_type_limit',
    group: 'group_event_type',
    collective: 'collective_event_types',
    round_robin: 'round_robin_event_types'
  }
}

export const getFeatureType = (kind, poolingType) => poolingType || kind

export const getFeatureKey = (featureType, context) => EVENT_TYPE_FEATURE_RESTRICTIONS[context][featureType]

export const featureTypeIsKind = (featureType) => ['solo', 'group'].includes(featureType)

export const canCreateEventType = (featureType, policy) => {
  const policyFeature = featureTypeIsKind(featureType)
    ? `create${upperFirst(camelCase(featureType))}UserEventType`
    : `create${upperFirst(camelCase(featureType))}EventType`

  return policy[policyFeature]
}
